import { useBlinkContextWithValidation, } from '@thoughtspot/blink-context';
import { useEffect } from 'react';
const COMS_METRICS_SERVICE_CONTRACT = [
    { propName: 'collectEvent', propType: 'function' },
];
const COMS_SESSION_SERVICE_CONTRACT = [
    { propName: 'getUserGuid', propType: 'function' },
    { propName: 'getUserDisplayName', propType: 'function' },
    { propName: 'clearSessionInfo', propType: 'function' },
    { propName: 'isLoggedIn', propType: 'function' },
    { propName: 'markManuallyLoggedOut', propType: 'function' },
    { propName: 'getOnUserLoggedOut', propType: 'function' },
    { propName: 'clearSessionInfo', propType: 'function' },
    { propName: 'setLast401Path', propType: 'function' },
    { propName: 'setSessionInfo', propType: 'function' },
    { propName: 'isInAppNotificationEnabled', propType: 'function' },
    { propName: 'isSlackBotEnabled', propType: 'function' },
    { propName: 'isMsTeamsBotEnabled', propType: 'function' },
    {
        propName: 'isMsTeamsNotificationPreferenceEnabled',
        propType: 'function',
    },
    { propName: 'onThirdPartyServicesInitiated', propType: 'object' },
    { propName: 'isOrgPerUrlEnabled', propType: 'function' },
    { propName: 'isCopilotEnabled', propType: 'function' },
    { propName: 'isSlackInitiallyConnectedByUser', propType: 'function' },
    { propName: 'isAdminTabVisible', propType: 'function' },
    { propName: 'hideOrgSwitcherUi', propType: 'function' },
    { propName: 'isOrgUiEnabled', propType: 'function' },
    { propName: 'shouldLogoutWithRedirect', propType: 'function' },
    { propName: 'isApplicationSwitcherHidden', propType: 'function' },
    {
        propName: 'showOrgSwitcherToUsersWithMultipleOrgs',
        propType: 'function',
    },
    { propName: 'getAccessibleOrgs', propType: 'function' },
];
const COMS_NAV_SERVICE_CONTRACT = [
    { propName: 'getUrlHash', propType: 'function' },
    { propName: 'goToLogin', propType: 'function' },
    { propName: 'reload', propType: 'function' },
    { propName: 'goToUserPreference', propType: 'function' },
    { propName: 'goToUrl', propType: 'function' },
];
const COMS_SYSTEM_CONFIG_SERVICE_CONTRACT = [
    { propName: 'getOidcLoginUriFromIssuers', propType: 'function' },
    { propName: 'isOidcEnabled', propType: 'function' },
    { propName: 'isOktaEnabled', propType: 'function' },
];
export const useBlinkContextForCOMS = () => {
    const [validate, blinkContext] = useBlinkContextWithValidation({
        metricsServiceContract: COMS_METRICS_SERVICE_CONTRACT,
        sessionServiceContract: COMS_SESSION_SERVICE_CONTRACT,
        navServiceContract: COMS_NAV_SERVICE_CONTRACT,
        systemConfigServiceContract: COMS_SYSTEM_CONFIG_SERVICE_CONTRACT,
    });
    return blinkContext;
};
export const useValidateBlinkContextForCOMS = () => {
    const [validate] = useBlinkContextWithValidation({
        metricsServiceContract: COMS_METRICS_SERVICE_CONTRACT,
        sessionServiceContract: COMS_SESSION_SERVICE_CONTRACT,
        navServiceContract: COMS_NAV_SERVICE_CONTRACT,
        systemConfigServiceContract: COMS_SYSTEM_CONFIG_SERVICE_CONTRACT,
    });
    useEffect(() => {
        validate('COMS');
    }, [validate]);
};
//# sourceMappingURL=coms-blink-context.js.map